<template>
  <div>
    <TheTopProgressBar :ratio="3/4"/>
    <TheHeader
      :back-route="computedBackRoute"
      forward-route="management-report"
    />
    <BaseSection v-if="opportunity">
      <BaseTitleGroup
        :title="$t('Kerala Analysis')"
        :subtitle="opportunity.data.attributes.name"
        class="mb-8"
      />
      <BaseParagraph class="mb-8">
        {{ $t('Kerala Analysis description') }}
      </BaseParagraph>
      <iframe
        v-if="opportunity.data.attributes.keralaAnalysisDocumentId"
        :src="`https://drive.google.com/file/d/${opportunity.data.attributes.keralaAnalysisDocumentId}/preview`"
        class="w-full h-64 mb-8"
      />
      <BaseButton
        :title="$t('Management report')"
        to="management-report"
        class="mb-4"
        fixed-bottom
      />
    </BaseSection>
  </div>
</template>

<script>
import loadOpportunity from '../mixins/loadOpportunity';
import customBackRoute from '../mixins/customBackRoute';
import TheHeader from '../components/TheHeader.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseParagraph from '../components/BaseParagraph.vue';
import TheTopProgressBar from '../components/TheTopProgressBar.vue';
import BaseButton from '../components/BaseButton.vue';

export default {
  name: 'KeralaAnalysis',
  components: {
    TheHeader,
    BaseSection,
    BaseTitleGroup,
    BaseParagraph,
    TheTopProgressBar,
    BaseButton,
  },
  mixins: [loadOpportunity, customBackRoute],
  data() {
    return {
      backRoute: 'operation-details',
    };
  },
};
</script>
